import { render, staticRenderFns } from "./characterColumn.vue?vue&type=template&id=3d5ce4e4&scoped=true"
import script from "./characterColumn.vue?vue&type=script&lang=js"
export * from "./characterColumn.vue?vue&type=script&lang=js"
import style0 from "./characterColumn.vue?vue&type=style&index=0&id=3d5ce4e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ce4e4",
  null
  
)

export default component.exports